console.log(process.env);
const firebaseConfig = {
  apiKey: "AIzaSyAVcw0_iGLUGG7GsTMzPgozlJkgRXxbUKo",

  authDomain: "genius-car-4b50d.firebaseapp.com",

  projectId: "genius-car-4b50d",

  storageBucket: "genius-car-4b50d.appspot.com",

  messagingSenderId: "348559083000",

  appId: "1:348559083000:web:30f6456f20bbb287a5420d"
};

export default firebaseConfig;
